import * as React from "react";
const SvgEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("title", null, "sign-badge-circle"), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12 }));
export default SvgEllipse;
